import { motion, useReducedMotion } from "framer-motion";
import clsx from "clsx";

const BLOBS = [
  {
    // بالا راست
    className:
      "top-[-200px] end-[-150px] h-[500px] w-[500px] sm:h-[600px] sm:w-[600px]",
    color: "var(--mesh-1)",
    duration: 22,
    delay: 0,
    x: [-80, 0],
    y: [60, 0],
    scale: [1.15, 1, 1.15],
  },
  {
    // پایین چپ
    className:
      "bottom-[-200px] start-[-150px] h-[440px] w-[440px] sm:h-[520px] sm:w-[520px]",
    color: "var(--mesh-2)",
    duration: 26,
    delay: 1,
    x: [80, 0],
    y: [-60, 0],
    scale: [1.2, 1, 1.2],
  },
  {
    // وسط
    className:
      "top-[40%] start-[30%] h-[380px] w-[380px] sm:h-[480px] sm:w-[480px]",
    color: "var(--mesh-3)",
    duration: 30,
    delay: 2,
    x: [-60, 0],
    y: [-80, 0],
    scale: [0.9, 1, 0.9],
  },
];

export default function MeshBlobs() {
  const reduce = useReducedMotion();

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
    >
      {BLOBS.map((blob, i) => (
        <motion.div
          key={i}
          animate={
            reduce
              ? {}
              : {
                  x: blob.x,
                  y: blob.y,
                  scale: blob.scale,
                }
          }
          transition={{
            duration: blob.duration,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
            delay: blob.delay,
          }}
          className={clsx("absolute rounded-full blur-[100px]", blob.className)}
          style={{
            background: `radial-gradient(circle, ${blob.color}, transparent 70%)`,
          }}
        />
      ))}
    </div>
  );
}